import {
  LuChartBar,
  LuCreditCard,
  LuServer,
  LuSettings,
  LuSlidersHorizontal,
  LuUsers,
} from 'react-icons/lu';
import { DICTIONARY } from '@/config/dictionary';
import { APP_PATHS } from '@/config/routes/app-paths';
import type { DashboardNavItem } from '@/config/routes/dashboard-nav-item';

const nav = DICTIONARY.dashboard.navigation;

export const DASHBOARD_NAV_ITEMS: DashboardNavItem[] = [
  { label: nav.overview, to: APP_PATHS.overview, icon: LuChartBar },
  { label: nav.billing, to: APP_PATHS.billing, icon: LuCreditCard },
  { label: nav.services, to: APP_PATHS.services, icon: LuServer },
  { label: nav.wholesalerSettings, to: APP_PATHS.wholesalerSettings, icon: LuSlidersHorizontal },
  { label: nav.team, to: APP_PATHS.team, icon: LuUsers },
  { label: nav.adminSettings, to: APP_PATHS.adminSettings, icon: LuSettings },
];
